import type { Feed, FeedEntry, UIComponent } from '~/services/layout';
import type { PopupMenuActionsSource } from '../hooks/use-popup-menu-availability';
import type { PopupMenuPointer, PopupMenuTriggerSource } from '../types';

export const SHOW_POPUP_MENU_ACTION: string = 'showPopupMenu';

export const HIDE_POPUP_MENU_ACTION: string = 'hidePopupMenu';

export type PopupMenuFavoriteState = {
  isFavorite: boolean;
  isAvailable: boolean;
};

export type PopupMenuFavoriteStateListener = () => void;

/**
 * Live Favourite state and toggle of the entry a cell menu acts on.
 * TODO: drop once FavoriteController lands on main — the host then reads
 * the entry's state from the controller by entry id.
 */
export type PopupMenuFavoriteSource = {
  getState: () => PopupMenuFavoriteState;
  subscribe: (listener: PopupMenuFavoriteStateListener) => () => void;
  toggle: () => void;
};

export type PopupMenuRequestContent =
  | {
      kind: 'entry';
      entry: FeedEntry;
      actionsSource: PopupMenuActionsSource;
      favorite?: PopupMenuFavoriteSource;
    }
  | { kind: 'feed'; feed: Feed };

export type ShowPopupMenuOptions = {
  /** the element the menu is anchored to (and focus returns to on close) */
  triggerElement: HTMLElement;
  source: PopupMenuTriggerSource;
  /** viewport position to anchor the menu at instead of the trigger (right-click) */
  pointer?: PopupMenuPointer;
  uiComponent: UIComponent;
  content: PopupMenuRequestContent;
  zIndex?: number;
  quickActionAlias?: string;
  /** who made the request; an owner-scoped hide closes only that owner's menu */
  owner?: string;
};

export type HidePopupMenuOptions = {
  /** hide only when the current request belongs to this owner */
  owner?: string;
};

export type PopupMenuTrigger = {
  triggerElement: HTMLElement;
  source: PopupMenuTriggerSource;
  pointer?: PopupMenuPointer;
};

export type PopupMenuTriggerHandler = (trigger: PopupMenuTrigger) => void;
